import { bindActionCreators, configureStore } from "@reduxjs/toolkit";

import { actionCreators, rootReducer } from ".";

export const store = configureStore({ reducer: rootReducer });

bindActionCreators(actionCreators, store.dispatch);
